import { __assign, __read } from "tslib";
import React, { useState } from 'react';
import { Button } from '@tencent/tea-component/lib/button';
import { Input } from '@tencent/tea-component/lib/input';
import { BuyIcon } from '../buyicon';
export function BuyInputPassword(props) {
    var _a = __read(useState(false), 2), show = _a[0], setShow = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, __assign({}, props, { type: show ? 'text' : 'password' })),
        React.createElement(Button, { type: "weak", className: "buy-btn__pwd", onClick: function () { return setShow(!show); } },
            React.createElement(BuyIcon, { type: show ? 'pwd-show' : 'pwd-hide' }))));
}
//# sourceMappingURL=BuyInputPassword.js.map